import { render, staticRenderFns } from "./modulo.vue?vue&type=template&id=9ef7708a&scoped=true"
import script from "./modulo.vue?vue&type=script&lang=js"
export * from "./modulo.vue?vue&type=script&lang=js"
import style0 from "./modulo.vue?vue&type=style&index=0&id=9ef7708a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef7708a",
  null
  
)

export default component.exports